import styled from 'styled-components/macro';
import { MiniButton } from '@yme/atoms/mini-button';
import { boxStyled } from '@yme/molecules/filter-dropdown/styled';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
export const FiltersButtonStyled = styled(MiniButton) `
  justify-content: flex-start;
  width: 100%;

  ${boxStyled}
`;
export const LabelStyled = styled.span `
  display: block;
  margin-bottom: 8px;
  color: ${colorCoreBlack900Base};

  ${getTextStyles('Ubuntu', 400, 16, 24)}

  ${ADAPTIVE.minWidth.desktop} {
    ${getTextStyles('Ubuntu', 500, 14, 20)}
  }
`;
export const FiltersListStyled = styled.ul `
  margin: 0;
  padding: 0;
`;
